import styled, { css } from 'styled-components';

import { ReactComponent as ChevronDown } from '../../../assets/images/blueTheme/chevronArrow.svg';

export const StyledMultiSelectWrapper = styled.div`
  position: relative;

  svg {
    width: 16px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  padding-left: ${({ theme }): string => theme.spacers!.spacer02};
`;

export const CloseIconWrapper = styled(IconWrapper)`
  padding-right: ${({ theme }): string => theme.spacers!.spacer02};
  border-right: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.fg1[2]};

  :hover {
    cursor: pointer;
  }
`;

export const StyledInput = styled.div<{ $error: boolean; $open: boolean }>(
  ({ theme: { spacers, admanColors, colors }, $error, $open }) => css`
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${$error ? admanColors!.red.dark.fg[2] : admanColors!.gray.dark.fg[1]};
    border-radius: 4px;
    padding: ${spacers!.spacer02};
    width: 100%;
    box-shadow: ${$open ? `0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.dark.bg1[0]}` : ``};

    :hover {
      cursor: pointer;
    }
  `
);

export const StyledInputIcons = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledInputText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 450px;
  white-space: nowrap;
`;

export const StyledChevronDown = styled(ChevronDown)(
  ({ theme: { admanColors } }) => css`
    rotate: 270deg;

    path {
      fill: ${admanColors!.gray.light.fg1[0]};
    }
  `
);

export const StyledBoldText = styled.span`
  font-weight: bold;
`;

export const ErrorBlock = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    margin: ${spacers!.spacer01} 0;
    font-family: InspireTWDC;
    font-size: 15px;
    line-height: 18px;
    color: ${admanColors!.red.dark.fg[2]};
  `
);
